/**
 * Created by jack.gill on 08/01/2018.
 */
var ChallengeAward = function (config) {

    PIXI.Container.call(this);

    this.config = config;

    this.build();

    if (this.config.doTween) {
        this.doResultsTween();
    }
    else {
        this.displayCurrentProgress();
    }

};


ChallengeAward.prototype = Object.create(PIXI.Container.prototype);
ChallengeAward.prototype.constructor = ChallengeAward;

ChallengeAward.prototype.build = function Build() {

    var barFill, barComplete, barOverlay, rewardBack,
        reward, rewardSparkles, rewardGlow, challengeIcon, keyWord, tallyText, challenge;

    challenge = this.config.json.challenges[this.config.key];

    barOverlay = Widgets.createAsset(this.config.json.challenges_bar_overlay);
    barFill = Widgets.createAsset(this.config.json.challenges_bar_fill);
    barComplete = Widgets.createAsset(this.config.json.challenges_bar_complete);
    rewardBack = Widgets.createAsset(this.config.json.rewards_back);
    reward = Widgets.createAsset(this.config.json.rewards_symbol);
    rewardSparkles = Widgets.createAsset(this.config.json.rewards_sparkle);
    rewardGlow = Widgets.createAsset(this.config.json.rewards_glow);

    keyWord = new PIXI.extras.BitmapText(challenge.keyword, {
        font: challenge.text.size + "px Futura",
        tint: challenge.text.tint
    });
    Widgets.setAssetParams(keyWord, challenge.text);

    challengeIcon = Widgets.createAsset(challenge.icon);

    tallyText = new PIXI.extras.BitmapText("", {
        font: challenge.text.size + "px Futura",
        tint: challenge.text.tint
    });

    barOverlay.x = 40;

    barFill.position.y = barOverlay.position.y;
    barFill.position.x = barOverlay.position.x;
    barFill.anchor.set(0, 0.5);
    barFill.position.x -= barOverlay.width * 0.5;
    barFill.position.x += 7;

    barComplete.alpha = 0;
    barComplete.position.y = barOverlay.position.y;
    barComplete.position.x = barOverlay.position.x;

    rewardBack.position.y = barOverlay.position.y - 10;
    rewardBack.position.x = barOverlay.position.x;
    rewardBack.position.x -= (rewardBack.width * 0.5) + (barOverlay.width * 0.5) + 15;

    reward.position.set(rewardBack.position.x, rewardBack.position.y);

    rewardSparkles.position.set(rewardBack.position.x, rewardBack.position.y);

    rewardGlow.position.set(rewardBack.position.x, rewardBack.position.y);

    keyWord.position.x = (barOverlay.position.x - (barOverlay.width * 0.5)) + 5;
    keyWord.position.y = (barOverlay.position.y - (barOverlay.height)) - (keyWord.textHeight * 0.5) - 8;

    challengeIcon.position.x = keyWord.position.x;
    challengeIcon.position.x += keyWord.textWidth + (challengeIcon.width * 0.5) + 10;
    challengeIcon.position.y = keyWord.position.y;
    challengeIcon.position.y += (keyWord.textHeight * 0.5);
    challengeIcon.anchor.set(0.5, 0.5);

    tallyText.position.x = challengeIcon.position.x;
    tallyText.position.x += (challengeIcon.width * 0.5) + 10;
    tallyText.position.y = keyWord.position.y;

    keyWord.position.x = (barOverlay.position.x - (barOverlay.width * 0.5)) + 5;
    keyWord.position.y = (barOverlay.position.y - (barOverlay.height)) - (keyWord.textHeight * 0.5) - 8;

    rewardGlow.alpha = 0;
    rewardGlow.scale.set(0, 0);
    rewardSparkles.alpha = 0;

    if (this.config.doTween || (this.config.endScore !== this.config.levelValue)) {
        reward.alpha = 0;
    }

    this.barFill = barFill;
    this.barComplete = barComplete;
    this.barOverlay = barOverlay;
    this.rewardBack = rewardBack;
    this.reward = reward;
    this.rewardSparkles = rewardSparkles;
    this.rewardGlow = rewardGlow;
    this.challengeIcon = challengeIcon;
    this.keyWord = keyWord;
    this.tallyText = tallyText;

    this.addChild(this.barFill);
    this.addChild(this.barComplete);
    this.addChild(this.barOverlay);
    this.addChild(this.rewardBack);
    this.addChild(this.reward);
    this.addChild(this.rewardSparkles);
    this.addChild(this.rewardGlow);
    this.addChild(this.challengeIcon);
    this.addChild(this.keyWord);
    this.addChild(this.tallyText);

};

ChallengeAward.prototype.displayCurrentProgress = function DisplayCurrentProgress() {

    var currentScoreText, finalScale;

    if (this.config.key !== "height") {
        currentScoreText = this.config.endScore + "/";
    }
    else {
        currentScoreText = "";
    }

    finalScale = Math.min(1, Math.value(0, this.config.levelValue, this.config.endScore));

    this.tallyText.text = currentScoreText + this.config.levelValue;

    this.barFill.scale.set(finalScale, 1);

};

ChallengeAward.prototype.doResultsTween = function DoResultsTween() {

    var initialScale, finalScale, onComplete;

    initialScale = Math.min(1, Math.value(0, this.config.levelValue, this.config.startScore));
    finalScale = Math.min(1, Math.value(0, this.config.levelValue, this.config.endScore));

    this.tallyText.scoreTweenValue = this.config.startScore;
    this.tallyText.scoreMax = this.config.levelValue;

    this.barFill.scale.set(initialScale, 1);

    TweenLite.to(this.tallyText, 1.0, {
        scoreTweenValue: this.config.endScore,
        ease: Power2.easeOut,
        delay: 0.5
    });

    onComplete = undefined;
    if (finalScale === 1) {
        onComplete = (function (that) {
            return function () {
                that.barComplete.alpha = 1;

                TweenLite.to(that.rewardGlow.scale, 1.0, {
                    x: 1,
                    y: 1,
                    ease: Power2.easeOut,
                    onStart: function() {
                        sound.play(Screens.json.audio.unlock, 1);
                    }.bind(this)
                });

                TweenLite.to(that.rewardGlow, 1.0, {
                    alpha: 1
                });

                TweenLite.to(that.rewardSparkles, 1.0, {
                    alpha: 1
                });

                TweenLite.to(that.rewardSparkles, 2.0, {
                    rotation: 2
                });

                TweenLite.to(that.rewardGlow, 1.0, {
                    alpha: 0,
                    delay: 1
                });

                TweenLite.to(that.rewardSparkles, 1.0, {
                    alpha: 0,
                    delay: 1
                });

                TweenLite.to(that.reward, 0.25, {
                    alpha: 1,
                    delay: 0.75
                });

                if (that.config.disappear) {
                    TweenLite.to(that, 0.25, {alpha: 0, delay: 2.5});
                    TweenLite.to(that.position, 0.25, {y: that.position.y + 20, delay: 2.5});
                }
            }
        }(this))
    }

    TweenLite.to(this.barFill.scale, 1.0, {
        x: finalScale,
        ease: Power2.easeOut,
        delay: 0.5,
        onComplete: onComplete
    });

};

ChallengeAward.prototype.update = function Update(delta) {

    if (this.config.doTween) {
        this.tallyText.text = Math.ceil(this.tallyText.scoreTweenValue) + "/" + this.tallyText.scoreMax;
    }

};

